module.exports = __webpack_public_path__ + "static/media/Sophie Himsworth Alcove Units (4).514a5ae0.jpg";